import { LOANS } from '../domain/constants.loans';

export default class LoansModalitiesAssembler {

  constructor(modalities) {
    this.modalities = modalities;
  }

  assemble() {
    const result = {};
    for (let loanId in LOANS.ID) {
      const loanIdValue = LOANS.ID[loanId];
      const purposes = this._findPurposesByHrId(loanId);
      result[loanIdValue] = purposes.map(this._mapPurpose);
    }

    return result;
  }

  _findPurposesByHrId(loanId) {
    const hrId = LOANS.ID_HR[loanId];
    const loanPurposes = this.modalities.find(modality => modality.code === hrId);
    let purposes = [];
    if (loanPurposes) {
      purposes = loanPurposes.purposes;
    }

    return purposes;
  }

  _mapPurpose(purpose) {
    return {
      value: purpose.code,
      option: purpose.description,
    };
  }

}



// WEBPACK FOOTER //
// ./client/app/loans.module/common/assemblers/loans.modalities.assembler.js